module.exports = __webpack_public_path__ + "static/media/04_avatar_male.89f96058.png";